import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';

import { getModuleData, getModuleMeta } from '../../../selectors/modules';
import { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { Props as LlamaFarmProps } from './LlamaFarm';

type Props = LlamaFarmProps & WidgetBoxProps;
type StateProps = Pick<
  Props,
  | 'profileOwnerUser'
  | 'isOwner'
  | 'isNewlyAddedModule'
  | 'isCurrentUserCoreMember'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  return {
    ...moduleData,
    isCurrentUserCoreMember: getCurrentUserHasCore(state),
    isNewlyAddedModule: Boolean(
      getModuleMeta(state, ownProps.moduleId).isNewlyAdded
    ),
    profileOwnerUser: getProfileOwnerUser(state),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
